// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__vrjoD","inner":"Form_inner__3g1q1","range":"Form_range__1s4bh","name":"Form_name__tXA6f","actions":"Form_actions__hu3Xt"};